import { useState, useEffect } from 'react';
import { get_rules, savechatbot, deletechatbot } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';

import Swal from 'sweetalert2';

export default function ChatbotModal({ device, onClose }) {
  const [rules, setRules] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [replyText, setReplyText] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [matchType, setMatchType] = useState('exact');
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const rulesPerPage = 5;

  const fetchRules = async () => {
    try {
      setFetching(true);
      const res = await get_rules(device.id);
      setRules(res.data || []);
    } catch (err) { console.error(err); } finally { setFetching(false); }
  };

  useEffect(() => { if (device?.id) fetchRules(); }, [device.id]);

  // 1. Helper to compress image to specifically under 20KB
  const compressImage = (file, maxSizeKB = 20) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // Start with a max dimension of 800px to reduce initial size
          const MAX_WIDTH = 800;
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // Recursive function to lower quality until size is < 20KB
          const adjustQuality = (quality) => {
            const base64 = canvas.toDataURL('image/jpeg', quality);
            const sizeKB = (base64.length * (3 / 4)) / 1024;

            if (sizeKB > maxSizeKB && quality > 0.1) {
              return adjustQuality(quality - 0.1);
            }
            resolve(base64);
          };

          adjustQuality(0.7); // Start at 70% quality
        };
      };
    });
  };

  // 2. Updated handleAddRule inside your component
  const handleAddRule = async (special = null) => {
    debugger
    const k = special ? special.keyword : keyword;
    const r = special ? special.reply : replyText;

    if (!k) return Swal.fire("Keyword required");

    setLoading(true);
    try {
      let base64String = null;
      let fileName = null;

      if (selectedFile) {
        // Check if it's an image to apply compression
        debugger
        if (selectedFile.type.startsWith('image/')) {
          base64String = await compressImage(selectedFile, 20);
        } else {
          // For PDFs or Docs, just convert to Base64 (Compression not easily possible for docs)
          base64String = await new Promise((res) => {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onload = () => res(reader.result);
          });
        }
        fileName = selectedFile.name;
      }

      debugger

      const data = {
        device_id: device.id,
        user_id: device.user_id || JSON.parse(localStorage.getItem('user'))?.data?.id,
        keyword: k,
        reply_text: r || '',
        match_type: special ? 'exact' : matchType,
        status: '1',
        media_url: base64String, // Compressed Base64 string
        filename: fileName
      };

      const res = await savechatbot(data);
      if (res.status === 200 || res.success) {
        setKeyword(''); setReplyText(''); setSelectedFile(null);
        fetchRules();
      }
    } catch (err) {
      console.error("Save error:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredRules = rules.filter(r =>
    r.keyword?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    r.reply_text?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRule = currentPage * rulesPerPage;
  const indexOfFirstRule = indexOfLastRule - rulesPerPage;
  const currentRules = filteredRules.slice(indexOfFirstRule, indexOfLastRule);
  const totalPages = Math.ceil(filteredRules.length / rulesPerPage);

  const hasRule = (key) => rules.find(r => r.keyword === key);






  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'flex-start', paddingTop: '30px' }}>
      <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '1000px', width: '95%', borderRadius: '20px', overflow: 'hidden', padding: '0' }}>

        {/* Header */}
        <div className="bg-primary p-4 d-flex justify-content-between align-items-center text-white">
          <div>
            <h5 className="fw-bold mb-0">WhatsApp AI Chatbot Dashboard</h5>
            <p className="mb-0 x-small text-white-50">Configuring: {device.device_name} (ID: {device.id})</p>
          </div>
          <button className="btn btn-light btn-sm rounded-pill px-3 fw-bold" onClick={onClose}>Close</button>
        </div>

        <div className="container-fluid">
          <div className="row">
            {/* Sidebar: Creation Form */}
            <div className="col-lg-4 bg-light p-4" style={{ minHeight: '550px' }}>
              <h6 className="fw-bold mb-3 text-primary small text-uppercase">1. Setup System Rules</h6>
              <div className="row g-2 mb-4">
                {['@welcome', '@default'].map(sys => (
                  <div key={sys} className="col-6">
                    <button
                      className={`btn btn-sm w-100 py-2 border ${hasRule(sys) ? 'btn-success' : 'btn-white bg-white'}`}
                      onClick={() => {
                        const msg = prompt(`Enter ${sys === '@welcome' ? 'Welcome' : 'Fallback'} message:`);
                        if (msg) handleAddRule({ keyword: sys, reply: msg });
                      }}
                    >
                      {sys === '@welcome' ? 'Welcome' : 'Fallback'} {hasRule(sys) ? '✓' : '+'}
                    </button>
                  </div>
                ))}
              </div>

              <h6 className="fw-bold mb-3 text-primary small text-uppercase">2. Create Custom Rule</h6>
              <div className="card border-0 shadow-sm rounded-3 p-3">
                <div className="mb-2">
                  <label className="x-small fw-bold text-muted">User Keyword</label>
                  <input className="form-control form-control-sm" placeholder="e.g. Price" value={keyword} onChange={e => setKeyword(e.target.value)} />
                </div>

                <div className="mb-2">
                  <label className="x-small fw-bold text-muted">Bot Reply Text</label>
                  <textarea className="form-control form-control-sm" rows="10" placeholder="Enter text message..." value={replyText} onChange={e => setReplyText(e.target.value)} />
                </div>

                {/* <div className="mb-3">
                  <label className="x-small fw-bold text-muted">Media Attachment</label>
                  <input type="file" id="mediaUpload" className="d-none" onChange={(e) => setSelectedFile(e.target.files[0])} />
                  <label htmlFor="mediaUpload" className={`btn btn-sm w-100 border-dashed py-2 ${selectedFile ? 'btn-info text-white' : 'btn-outline-secondary'}`}>
                    {selectedFile ? `📎 ${selectedFile.name.substring(0, 15)}...` : '📁 Add Image/Document'}
                  </label>
                  {selectedFile && <div className="text-center mt-1"><small className="text-danger pointer" onClick={() => setSelectedFile(null)}>Remove file</small></div>}
                </div> */}

                <div className="mb-3">
                  <select className="form-select form-select-sm" value={matchType} onChange={e => setMatchType(e.target.value)}>
                    <option value="exact">Exact Match</option>
                    <option value="contains">Contains Keyword</option>
                  </select>
                </div>

                <button className="btn btn-primary w-100 fw-bold py-2 shadow-sm" onClick={() => handleAddRule()} disabled={loading}>
                  {loading ? 'Processing...' : 'Save & Deploy'}
                </button>
              </div>
            </div>

            {/* Main Content: Rules List */}
            <div className="col-lg-8 p-4 bg-white">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="fw-bold mb-3 text-color-dark-upper" style={{ letterSpacing: '0.5px' }}>
                  <i className="bi bi-clock-history me-2"></i>
                  Actve Bot Rules
                </h6>
                <div className="input-group input-group-sm w-50">
                  <span className="input-group-text bg-white border-end-0"><i className="bi bi-search"></i></span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0"
                    placeholder="Search keywords..."
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                  />
                </div>
              </div>

              <div style={{ minHeight: '400px' }}>
                {fetching ? (
                  <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : currentRules.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted small">No rules found. Start by adding one on the left.</p>
                  </div>
                ) : (
                  currentRules.map(rule => (
                    <div key={rule.id} className="card mb-2 border shadow-none bg-light-hover" style={{ transition: '0.3s' }}>
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="flex-grow-1">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span className={`badge ${rule.keyword.startsWith('@') ? 'bg-dark' : 'bg-primary'} px-3`}>
                                {rule.keyword}
                              </span>
                              <span className="x-small text-muted fw-bold">{rule.match_type.toUpperCase()}</span>
                              {rule.media_url && <span className="badge bg-info text-white">📎 MEDIA</span>}
                            </div>
                            <p className="mb-0 small text-dark opacity-75">{rule.reply_text || <i className="text-muted">(Media only)</i>}</p>
                          </div>
                          <button className="btn btn-sm btn-link text-danger" onClick={() => deletechatbot(rule.id).then(fetchRules)}>
                            🗑️
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Pagination */}
              {!fetching && totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-4 border-top pt-3">
                  <span className="text-muted x-small">Showing {indexOfFirstRule + 1} to {Math.min(indexOfLastRule, filteredRules.length)} of {filteredRules.length}</span>
                  <nav>
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                      </li>
                      {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}